import React, { useState, useEffect } from 'react';
import FiltrosInicio from './FiltrosInicio';
import TablaInicio from './TablaInicio';
import PaginacionInicio from './PaginacionInicio';
import { optionsPartido } from '../datos/options';

const TablaInicioContainer = React.forwardRef(({
    data, 
    isLoading, 
    onEditarRegistro,
    setNewEditandoId, 
    handlePreviewClick, 
    arrayEditando, 
    handleIsEditing,
    onDataLoaded
}, ref) => {
    // Estados para los datos y la carga
    const [datosOriginales, setDatosOriginales] = useState([]);
    const [datosFiltrados, setDatosFiltrados] = useState([]);
    const [error, setError] = useState(null);

    // Estados para los filtros
    const [filters, setFilters] = useState({
        encargado_proyecto: '',
        partido_nombre: '',
        organismo_solicitante: '',
        area_responsable: '',
        tipo_subsidio: '',
        programa_lineamiento: '',
        estado: '',
        search: ''
    });
    
    // Estado para el término de búsqueda
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTimeout, setSearchTimeout] = useState(null);

    // Estados para la paginación
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    // Efecto para cargar datos iniciales
    useEffect(() => {
        console.log('📥 Datos recibidos en TablaInicioContainer:', data);
        setDatosOriginales(data);
        setDatosFiltrados(data);
        
        // Solo llamar a onDataLoaded si hay datos y es diferente del estado anterior
        if (onDataLoaded && data && data.length > 0) {
            console.log('🔄 Llamando a onDataLoaded con', data.length, 'registros');
            onDataLoaded(data);
        }
    }, [data]);  // Removí onDataLoaded de las dependencias para evitar bucles

    // Calcular datos paginados
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = datosFiltrados.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(datosFiltrados.length / itemsPerPage);

    // Manejar cambio de página
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Manejar cambio de items por página
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    // Manejar cambio en los filtros
    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        console.log("NAME --->", name)
        console.log("VALUE --->", value)
        
        
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Limpiar filtros
    const limpiarFiltros = () => {
        setFilters({
            encargado_proyecto: '',
            partido_nombre: '',
            organismo_solicitante: '',
            area_responsable: '',
            tipo_subsidio: '',
            programa_lineamiento: '',
            estado: '',
            search: ''            
        });
        setSearchTerm('');
    };

    // Efecto para aplicar filtros
    useEffect(() => {
        const aplicarFiltros = () => {
            let tempDatos = [...datosOriginales];

            // Aplicar filtros
            if (filters.encargado_proyecto) {
                tempDatos = tempDatos.filter(item => 
                    item.encargado_proyecto === filters.encargado_proyecto
                );
            }

            if (filters.partido_nombre) {
                const partidoSeleccionado = optionsPartido.find(
                    p => p.value === filters.partido_nombre
                );
                if (partidoSeleccionado) {
                    tempDatos = tempDatos.filter(
                        item => item.partido_nombre === partidoSeleccionado.label
                    );
                }
            }

            if (filters.organismo_solicitante) {
                tempDatos = tempDatos.filter(
                    item => item.organismo_solicitante === filters.organismo_solicitante
                );
            }

            if (filters.area_responsable) {
                tempDatos = tempDatos.filter(
                    item => item.area_responsable === filters.area_responsable
                );
            }

            if (filters.tipo_subsidio) {
                tempDatos = tempDatos.filter(
                    item => item.tipo_subsidio === filters.tipo_subsidio
                );
            }
            
            if (filters.estado) {
                tempDatos = tempDatos.filter(
                    item => item.estado === filters.estado
                );
            }
            
            if (filters.programa_lineamiento) {
                tempDatos = tempDatos.filter(
                    item => item.programa_lineamiento === filters.programa_lineamiento
                );
            }

            if (filters.search) {
                const searchTerm = filters.search.toLowerCase();
                tempDatos = tempDatos.filter(item =>
                    (item.nombre_obra && item.nombre_obra.toLowerCase().includes(searchTerm)) ||
                    (item.array_obras_expediente && item.array_obras_expediente.some(expediente => {
                        if (!expediente || expediente.objeto_o !== 'Proyecto' || !expediente.expediente_o) {
                            return false;
                        }
                        const expedienteStr = expediente.expediente_o.toString().toLowerCase();
                        return expedienteStr === searchTerm || expedienteStr.includes(searchTerm);
                    }))
                );
            }
            // Búsqueda general (usando el searchTerm con debounce)
            /*if (searchTerm) {
                // Si el término de búsqueda es muy corto, no hacemos nada
                //if (searchTerm.length < 2) {
                  //  return;
                //}
                
                tempDatos = tempDatos.filter(item => {
                    // Primero verificamos el nombre de la obra (búsqueda parcial)
                    if (item.nombre_obra && item.nombre_obra.toLowerCase().includes(searchTerm)) {
                        return true;
                    }
                    
                    // Solo si no coincide el nombre, buscamos en los expedientes (búsqueda exacta)
                    if (item.array_obras_expediente) {
                        return item.array_obras_expediente.some(expediente => {
                            // Verificamos que sea un proyecto y tenga expediente
                            if (expediente.objeto_o !== 'Proyecto' || !expediente.expediente_o) {
                                return false;
                            }
                            
                            // Convertimos a string y a minúsculas para la comparación
                            const expedienteStr = expediente.expediente_o.toString().toLowerCase();
                            
                            // Comparamos si el expediente es exactamente igual al término de búsqueda
                            // o si el término de búsqueda está contenido en el expediente
                            return expedienteStr === searchTerm || 
                                   expedienteStr.includes(searchTerm);
                        });
                    }
                    
                    return false;
                });
            }*/

            setDatosFiltrados(tempDatos);
            setCurrentPage(1); // Reiniciar a la primera página al aplicar filtros
        };

        /*
        if(filters.search) {
            const searchTerm= filters.search.toLowerCase();
            tempDatos = tempDatos.filter(item=>
            (item.nombre_obra && item.nombre_obra.toLowerCase().includes(searchTerm)) ||
            (item......)
            )
        }
        */

        aplicarFiltros();
    }, [filters, datosOriginales]);

    if (isLoading) {
        return <div className="text-center py-4">Cargando datos...</div>;
    }

    if (error) {
        return <div className="text-red-500 text-center py-4">Error: {error}</div>;
    }

    return (
        <div className="w-full p-4">
            <h2 className="text-2xl font-bold mb-4">Listado de Proyectos</h2>
            
            <FiltrosInicio 
                filters={filters}
                setFilters={setFilters}
                data={datosOriginales}
                datosFiltrados={datosFiltrados}
                handleFilterChange={handleFilterChange}
                limpiarFiltros={limpiarFiltros}
                searchTerm={searchTerm}
                onSearchChange={(e) => handleFilterChange(e)}
                
                
            />
            
            <div className="overflow-x-auto">
                <TablaInicio 
                    data={currentItems} 
                    isLoading={isLoading}
                    onEditarRegistro={onEditarRegistro}
                    setNewEditandoId={setNewEditandoId}
                    handlePreviewClick={handlePreviewClick}
                    arrayEditando={arrayEditando}
                    handleIsEditing={handleIsEditing}
                />
            </div>
            
            <PaginacionInicio
                currentPage={currentPage}
                totalPages={totalPages}
                itemsPerPage={itemsPerPage}
                totalItems={datosFiltrados.length}
                onPageChange={handlePageChange}
                onItemsPerPageChange={handleItemsPerPageChange}
            />
        </div>
    );
});

export default TablaInicioContainer;
